@if (locations) {
  <mat-list>
    @for (location of locations; track location) {
      <bc-location-list-item
        [location]="location"
        class="business-navbar__location-list-item"
        (selected)="onLocationSelected()"
        [iconUrl]="brandingAppIconUrl$ | async"
      ></bc-location-list-item>
    }
  </mat-list>
}
